var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"status-tag",class:`status-tag--${_vm.tagType}`},[(_vm.icon)?_c('Icon',{staticClass:"status-tag__icon",attrs:{"value":_vm.icon,"size":"20"}}):_vm._e(),_c('span',{staticClass:"status-tag__label"},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }